import { useMemo } from 'react';
import classNames from 'classnames';

import { prettyBytes, prettyDuration, prettyResolution } from 'components/app/_helpers/_app.helper';
import { useAppSelector } from 'store/store-hooks';

import styles from './_fc-info.module.scss';

export const FcInfo = () => {
  const { name, version } = useAppSelector((state) => state.fc__data);
  const meta = version?.payment?.price ?? version?.subscription?.price;

  const info = useMemo(
    () => [
      { label: 'Name', value: name ?? '' },
      {
        label: 'Resolution',
        value: version?.height && version?.width ? prettyResolution(version.width, version.height) : '-',
      },
      {
        label: 'Frame rate',
        value: version?.frameRate ? `${Math.ceil(version?.frameRate)}fps` : '-',
      },
      {
        label: 'File size',
        value: version?.size ? prettyBytes(version?.size) : '-',
      },
      {
        label: 'Duration',
        value: version?.duration ? prettyDuration(version.duration) : '-',
      },
      {
        label: 'Watermark',
        value: meta?.watermark ?? '-',
      },
      {
        label: 'Tier',
        value: meta?.name ?? '-',
      },
    ],
    [name, version]
  );

  return (
    <div className={classNames(styles.FcInfo)}>
      {info.map((row) => (
        <p key={row.label}>
          <b>{`${row.label}`}</b>
          <span title={row.value}>{`${row.value}`}</span>
        </p>
      ))}
    </div>
  );
};
